export const HOME_PAGE = '/home';
export const PRIVACY_PAGE = '/privacy';
export const REFUND_PAGE = '/refund';
export const MARKET_PAGE = '/market';
export const CHILD_SAFETY_PAGE = '/child-safety';
